import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BrandPortfolioWorkspaceNameCell = _resolveComponent("BrandPortfolioWorkspaceNameCell");
  const _component_brand_portfolio_trending_cell = _resolveComponent("brand-portfolio-trending-cell");
  const _component_BrandPortfolioRevenueCell = _resolveComponent("BrandPortfolioRevenueCell");
  const _component_BrandPortfolioTacosCell = _resolveComponent("BrandPortfolioTacosCell");
  const _component_BrandPortfolioRoasCell = _resolveComponent("BrandPortfolioRoasCell");
  const _component_BrandPortfolioParentSpendCell = _resolveComponent("BrandPortfolioParentSpendCell");
  const _component_b_tr = _resolveComponent("b-tr");
  return _openBlock(), _createBlock(_component_b_tr, {
    class: _normalizeClass(["brand-portfolio-content", {
      clickable: $props.portfolio.seller_id == null
    }]),
    onClick: $options.onWorkspaceRowClickHandler
  }, {
    default: _withCtx(() => [_createVNode(_component_BrandPortfolioWorkspaceNameCell, {
      loading: $props.loading,
      portfolio: $props.portfolio,
      onOnWorkspaceNameClickHandler: $options.onWorkspaceNameClickHandler,
      onOnWorkspaceAlertClickHandler: $options.onWorkspaceAlertClickHandler
    }, null, 8, ["loading", "portfolio", "onOnWorkspaceNameClickHandler", "onOnWorkspaceAlertClickHandler"]), _createVNode(_component_brand_portfolio_trending_cell, {
      loading: $props.loading,
      portfolio: $props.portfolio,
      trendingType: "ytd"
    }, null, 8, ["loading", "portfolio"]), _createVNode(_component_brand_portfolio_trending_cell, {
      loading: $props.loading,
      portfolio: $props.portfolio,
      trendingType: "mtd"
    }, null, 8, ["loading", "portfolio"]), _createVNode(_component_brand_portfolio_trending_cell, {
      loading: $props.loading,
      portfolio: $props.portfolio,
      trendingType: "wtd"
    }, null, 8, ["loading", "portfolio"]), _createVNode(_component_BrandPortfolioRevenueCell, {
      loading: $props.loading,
      portfolio: $props.portfolio,
      periodLength: _ctx.periodLenght,
      period_data: $props.period_data,
      selected_period: $props.selected_period
    }, null, 8, ["loading", "portfolio", "periodLength", "period_data", "selected_period"]), _createVNode(_component_BrandPortfolioTacosCell, {
      loading: $props.loading,
      portfolio: $props.portfolio,
      periodLength: _ctx.periodLenght,
      period_data: $props.period_data,
      selected_period: $props.selected_period
    }, null, 8, ["loading", "portfolio", "periodLength", "period_data", "selected_period"]), _createVNode(_component_BrandPortfolioRoasCell, {
      loading: $props.loading,
      portfolio: $props.portfolio,
      periodLength: _ctx.periodLenght,
      period_data: $props.period_data,
      selected_period: $props.selected_period
    }, null, 8, ["loading", "portfolio", "periodLength", "period_data", "selected_period"]), _createVNode(_component_BrandPortfolioParentSpendCell, {
      loading: $props.loading,
      portfolio: $props.portfolio,
      children: $props.children
    }, null, 8, ["loading", "portfolio", "children"])]),
    _: 1
  }, 8, ["class", "onClick"]);
}